var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "switch-regions" },
    [
      _c("HKLSelect", {
        attrs: { options: _vm.regionOpts },
        on: { select: _vm.switchRegion },
        model: {
          value: _vm.selectedRegion,
          callback: function ($$v) {
            _vm.selectedRegion = $$v
          },
          expression: "selectedRegion",
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }